// Development(Staging), QA, Production
export const authRequestBQS: any = {
    scopes: ["api://ec7eab76-3901-4ca5-866b-4bb57082aaca/readwrite"],
};

export const authRequestCQS: any = {
    scopes: ["api://4368c2e5-8f68-46df-9850-5fc437899e08/readwrite"],
};

export const authRequestBc: any = {
    scopes: ["https://api.businesscentral.dynamics.com/user_impersonation"]
};

export const configurationBQS: any = {

    auth: {
        clientId: "02ae9a7b-321e-47dc-be36-2bbb4b98b8ca",
        authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        redirectUri: "https://bqs.brentmaterial.com/",
        postLogoutRedirectUri: "https://bqs.brentmaterial.com/",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};

export const configurationCQS: any = {

    auth: {
        clientId: "02ae9a7b-321e-47dc-be36-2bbb4b98b8ca",
        authority: "https://login.microsoftonline.com/659cf46c-6db7-4abb-8f6e-a8dbf5816da1",
        redirectUri: "https://cqs.brentmaterial.com/",
        postLogoutRedirectUri: "https://cqs.brentmaterial.com/",
    },
    cache: {
        cacheLocation: "localStorage", // or "sessionStorage"
        storeAuthStateInCookie: false,
    },
};



// WEBPACK FOOTER //
// ./ClientApp/config.production.ts